import React from 'react';

const About = ({ t }) => {
  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="about-grid">
          <div className="about-image-container">
            <img 
              src="/about-me.jpg" 
              alt="Professional developer" 
              className="about-image"
            />
          </div>
          
          <div className="about-content">
            <h2 className="section-title">{t.about.title}</h2>
            <p className="about-text">{t.about.p1}</p>
            <p className="about-text">{t.about.p2}</p>
            <p className="about-text highlight">{t.about.p3}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;